/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassStudentDropDownItemViewModel } from "../types/ClassStudentDropDownItemViewModel.ts";

export const classStudentDropDownItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do aluno na turma.")),
  courseId: z.optional(
    z.number().int().describe("ID do curso ao qual a turma pertence."),
  ),
  code: z.string().describe("Código identificador da turma.").nullish(),
  name: z.string().describe("Nome da turma.").nullish(),
  displayName: z
    .string()
    .describe("Nome formatado para exibição no dropdown.")
    .nullish(),
}) as unknown as ToZod<ClassStudentDropDownItemViewModel>;
